export const GET_LIST_COMPANIES_REQUEST = 'GET_LIST_COMPANIES_REQUEST';
export const GET_LIST_COMPANIES_SUCCESS = 'GET_LIST_COMPANIES_SUCCESS';
export const GET_LIST_COMPANIES_FAILURE = 'GET_LIST_COMPANIES_FAILURE';
